import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import LoginRegister from "../../../components/login_register/LoginRegister";
import { useAuth } from "../../../utils/authorization";
import { Avatar } from "@mui/material";
import { useGetAuthUserQuery } from "../../../redux/api/authApiSlice";
import Loader from "../../../components/custom/Loader";
import { assets } from "../../../assets";

export default function Header() {
  const { data, isLoading } = useGetAuthUserQuery();
  const { authToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const [searchParams] = useSearchParams();
  const loginParams = searchParams.get("login") || 0;

  const handleNavLinkClick = () => {
    if (isNavbarOpen) {
      setIsNavbarOpen(false);
    }
  };

  const handleTogglerClick = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const authUser = data?.data;

  useEffect(() => {
    if (Number(loginParams) === 1) {
      setShowModal(true);
    }
  }, [loginParams]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <header className="header noprint navbar-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="nav-inner">
                <nav className="navbar navbar-expand-lg">
                  <Link className="navbar-brand" to="/">
                    <img src={assets.logo} alt="Logo" />
                  </Link>
                  <button
                    className={`navbar-toggler ${isNavbarOpen ? "active" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded={isNavbarOpen}
                    aria-label="Toggle navigation"
                    onClick={handleTogglerClick}
                  >
                    <span className="toggler-icon" />
                    <span className="toggler-icon" />
                    <span className="toggler-icon" />
                  </button>
                  <div
                    className={`collapse navbar-collapse sub-menu-bar ${
                      isNavbarOpen ? "show" : ""
                    }`}
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="/"
                          onClick={handleNavLinkClick}
                        >
                          হোম পেইজ
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="copyright"
                          onClick={handleNavLinkClick}
                        >
                          কপিরাইট অফিস
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="rules"
                          onClick={handleNavLinkClick}
                        >
                          রেজিস্ট্রেশনের নিয়মাবলি
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="demo-form-literature"
                          onClick={handleNavLinkClick}
                        >
                          পূরণকৃত ফরম ও নমুনা
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="documents"
                          onClick={handleNavLinkClick}
                        >
                          সংযুক্তির নমুনা
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="faq"
                          onClick={handleNavLinkClick}
                        >
                          জিজ্ঞাসা
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="page-scroll"
                          to="contact"
                          onClick={handleNavLinkClick}
                        >
                          যোগাযোগ
                        </Link>
                      </li>
                      {authToken && authUser?.role_id && (
                        <>
                          {Number(authUser?.role_id) === 10 ? (
                            <li className="nav-item">
                              <Link
                                className="page-scroll"
                                style={{ paddingTop: "18px" }}
                                to="/user-profile"
                                onClick={handleNavLinkClick}
                              >
                                <Avatar
                                  src={
                                    data?.data?.image
                                      ? data.data.image
                                      : assets.avatar
                                  }
                                  sizes="sm"
                                  className="border"
                                  sx={{ width: 32, height: 32 }}
                                />
                              </Link>
                            </li>
                          ) : (
                            <li className="nav-item">
                              <Link
                                className="page-scroll"
                                to="/admin/dashboard"
                                onClick={handleNavLinkClick}
                              >
                                ড্যাশবোর্ড
                              </Link>
                            </li>
                          )}
                        </>
                      )}

                      {!authToken && (
                        <li className="nav-item pt-3 pb-2 loginButtonSm rounded">
                          <Link
                            onClick={() => setShowModal(true)}
                            className="rounded"
                          >
                            প্রবেশ করুন <span className="dir-part" />
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>

                  {!authToken && (
                    <div
                      className="signin-btn"
                      onClick={() => setShowModal(true)}
                    >
                      <span>
                        প্রবেশ করুন <span className="dir-part" />
                      </span>
                    </div>
                  )}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
      <LoginRegister show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
}
